// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.accordion-periods {
  background-color: #fff;
}
.accordion-periods .card-body {
  padding: 0;
}
.accordion-periods table {
  width: 100%;
  overflow-x: auto;
  overflow-y: visible;
}
@media (max-width: 767px) {
.accordion-periods table {
    display: block;
}
}
.accordion-periods .table th {
  border-bottom: 1px solid #dee2e6;
}
.accordion-periods .table th,
.accordion-periods .table td {
  border-top: none;
  border-right: 1px solid #d4d4d4;
  white-space: nowrap;
  background-color: #fff;
  text-align: left;
  padding: 15px;
}
.accordion-periods tr:nth-child(even) td {
  background-color: #f9f9f9;
}
.accordion-periods .table th:first-child {
  width: 5%;
}
.accordion-periods .table th:nth-child(4), .accordion-periods .table td:nth-child(4) {
  border-right: 0;
}
.accordion-periods .table td:first-child {
  text-align: center;
}
.accordion-periods .card-body tbody tr:nth-child(even) {
  background-color: #f9f9f9;
}
.accordion-periods .table th, .accordion-periods .table td {
  padding: 1.2rem;
}
.accordion-periods .btn-edit {
  color: #0078dc;
  padding: 0 5px 0 0;
}
.accordion-periods .btn-edit:hover {
  color: #56a6fc;
}
.accordion-periods .btn-edit:disabled {
  color: #adadad;
}
.accordion-periods .btn-edit:focus {
  box-shadow: none;
}
.accordion-periods .btn-delete:disabled {
  color: #adadad;
}
.accordion-periods .icon-edit {
  position: absolute;
  margin-top: 5px;
}
.accordion-periods .btn-edit span {
  padding-left: 20px;
}`, ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
